import { SxProps, Theme } from '@mui/material';
import {
  REPORT_FORM_GRID_SX,
  REPORT_MODAL_EDGE_BLEED_SX,
} from 'components/dataCreationForms/report/formUi/styles';
import {
  inspectionFormPageTitleSx,
  inspectionGridSx,
  inspectionSectionPaddingSx,
} from 'components/inspection/layout';

/** Section title row as in the inspection form; an optional action sits next to the title. */
export const sectionHeaderSx = {
  ...inspectionSectionPaddingSx,
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  columnGap: 2,
  mb: 2,
} satisfies SxProps<Theme>;

/** The first section sits below the page header divider. */
export const firstSectionHeaderSx = {
  ...sectionHeaderSx,
  mt: 4,
} satisfies SxProps<Theme>;

/** The inspection subheader font; the header row already carries the side padding. */
export const sectionTitleSx = inspectionFormPageTitleSx;

/**
 * Free-text fields back at the MUI input height: the shared autocomplete-with-text
 * squeezes its input to 1rem (and tunes its label to that height), which makes it
 * shorter than the selects next to it.
 */
const fullHeightTextFieldsSx = {
  '& .MuiAutocomplete-root .MuiInputBase-input': {
    height: '1.4375em',
  },
  '& .MuiAutocomplete-root .MuiFormLabel-root': {
    bottom: 'auto',
    lineHeight: '1.4375em',
  },
} satisfies SxProps<Theme>;

export const sectionGridSx = {
  ...inspectionGridSx,
  ...fullHeightTextFieldsSx,
} satisfies SxProps<Theme>;

/** In a dialog the form follows the send PDF report dialog. */
export const dialogFormSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2.5,
} satisfies SxProps<Theme>;

export const dialogSectionSx = {
  mt: 2,
} satisfies SxProps<Theme>;

export const dialogSectionDividerSx = REPORT_MODAL_EDGE_BLEED_SX;

export const dialogSectionHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  columnGap: 2,
} satisfies SxProps<Theme>;

export const dialogSectionGridSx = {
  ...REPORT_FORM_GRID_SX,
  ...fullHeightTextFieldsSx,
} satisfies SxProps<Theme>;
